import React from "react";
import {
  resolveNarrativeProvenanceView,
} from "../utils/intelligenceProvenance";
import "./IntelligenceProvenanceBadge.css";

/**
 * Compact snapshot provenance for a Campaign Notes / Campaign Strategy panel.
 *
 * Says which KPI snapshot the narrative was generated from, and — only when the
 * difference is proven — that newer KPI data exists. It never implies the saved
 * narrative describes the live KPI cards above it, and it never triggers a
 * rewrite: regeneration stays an explicit user action.
 *
 * The goal is trust, not clutter: one line normally, a second only when a real
 * difference needs surfacing.
 *
 * TWIN-PINNED: byte-identical in client (Cortex) and superadmin (Quantum).
 */
const IntelligenceProvenanceBadge = ({ provenance, className = "" }) => {
  const view = resolveNarrativeProvenanceView(provenance);

  return (
    <div
      className={`intel-provenance ${className}`.trim()}
      data-provenance-state={view.state}
    >
      <span className="intel-provenance-snapshot">{view.narrativeLabel}</span>
      {view.isStale ? (
        <span className="intel-provenance-stale" role="status">
          {view.staleNotice}
        </span>
      ) : null}
    </div>
  );
};

export default IntelligenceProvenanceBadge;
